import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateInput } from 'semantic-ui-calendar-react'
import Drawer from '~/components/Drawer'
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery'
import { formatDateGMT, handleErrors } from '~/utils/helpers'
import { UserEl } from '../../DairyFactory/DairyFactoryProfile/Users/style'
import { GlobalEl } from '~/styles/app'
import { useAuth } from '~/routes/components/AuthProvider'
import MilkMoneyAccountingService, { ToursRowType } from '~/api/services/milkMoneyAccounting'
import dayjs from 'dayjs'
import { useForm, useWatch } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'

interface Props {
  tourData: ToursRowType
  handleHiddenDrawer: () => void
  handleSubmit: () => void
}

const EditTourDate: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { handleHiddenDrawer, tourData } = props
  const { systemData: { languages, logged: { languageId } } } = useAuth();
  const languageLocal = languages.find(language => language.id === languageId);

  const [isBusy, setIsBusy] = useState(false)

  const { handleSubmit, control, reset, setValue } = useForm({
    mode: 'onSubmit'
  });

  const watchDate = useWatch({ control, name: 'date' })

  const {
    data: options,
    isLoading: isLoadingOptions
  } = MilkMoneyQuery.optionsDataTour()

  useEffect(() => {
    if (tourData) {
      fetchDateFrom()
    }
  }, [tourData])

  async function fetchDateFrom() {
    setIsBusy(true)
    try {
      const response = await MilkMoneyAccountingService.editTour(tourData.id)
      reset({
        vehicleNumber: response.data.vehicleNumber,
        date: dayjs(response.data.date).format('DD.MM.YYYY')
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function resetValues() {
    reset({
      vehicleNumber: '',
      date: ''
    })
  }

  async function onSubmit(data) {
    setIsBusy(true)
    data.date = dayjs(formatDateGMT(data.date)).format('YYYY-MM-DD')
    try {
      await MilkMoneyAccountingService.updateTour(tourData.id, data)
      resetValues()
      props.handleSubmit()
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsBusy(false)
    }
  }

  function renderContent() {
    return <>
      <FormFields.External
        control={control}
        name={'date'}
        label={t('Tour start')}
        onChange={(event, { name, value }) => setValue('date', value)}
        rules={{
          required: {
            value: true,
            message: t('Select tour start date')
          }
        }}
      >
        <DateInput
          placeholder={t('Tour start')}
          closable
          localization={languageLocal?.code}
          minDate={options?.dateFrom ? dayjs(options.dateFrom).format('DD.MM.YYYY') : null}
          closeOnMouseLeave={false}
          value={watchDate || ''}
          iconPosition='left'
          dateFormat='DD.MM.YYYY'
          onChange={(event, { value }) => setValue('date', value)}
        />
      </FormFields.External>
      <FormFields.Input
        control={control}
        name={'vehicleNumber'}
        noErrorMessage
        rules={{
          required: true
        }}
        label={t('Collection truck no.')}
        placeholder={t('Collection truck no.')}
      />
      <UserEl.DrawerFooter>
        <GlobalEl.DefaultOutlineButton type='button' onClick={() => {
          resetValues()
          handleHiddenDrawer();
        }}>
          {t('Cancel')}
        </GlobalEl.DefaultOutlineButton>
        <GlobalEl.PrimaryButton >
          {t('Update')}
        </GlobalEl.PrimaryButton>
      </UserEl.DrawerFooter>
    </>
  }

  return <Drawer
    onHide={() => {
      resetValues()
      handleHiddenDrawer();
    }}
    handleSubmit={handleSubmit(onSubmit)}
    isBusy={isLoadingOptions || isBusy}
    header={'Tourstart / Tourende ändern'}
    content={renderContent()}
    isVisible={Boolean(tourData)}
    closeOnEscape
  />
}
export default EditTourDate